import LeftPanel from "../LeftPanel/LeftPanel";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="logged-out page-signin">
      <section className="content-wrap light-bg">
    
        <LeftPanel heading="Privacy Policy" />

        <div className="col-content about w-60">
          <h3>Privacy Policy</h3>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
